import React from 'react';
import { useLocation } from "react-router";
//fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import styles from 'src/asset/scss/styles/userPartnerCalcDetail.module.scss';
//CompWrapper
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
//Comp
//comp
import ImgArea from 'src/webapp/views/component/ImgArea';

export default function PartnerList() {
    const { state } = useLocation();//state
    return (
        <Element tag={`div`} className={styles.infoArea}>
            <ul>
                <Element tag={`li`}>
                    <ImgArea className={["imgArea", styles.imgArea].join(" ")} src={state.IMG_SRC !== undefined ? state.IMG_SRC : null} alt={state.PARTNER_NAME} />
                    <Element tag={`div`}><Element tag={`label`} style={{ width: "8.5rem" }}>{state.PARTNER_NAME}</Element></Element><hr />
                    <Element tag={`div`} className={styles.dateArea}><FontAwesomeIcon icon="fa-light fa-calendar" /><Element tag={`span`} style={{ width: "10.625rem" }}>{state.CALC_START_DATE + ' ~ ' + state.CALC_END_DATE}</Element></Element><hr />
                    <Element tag={`div`} className={styles.dateArea}><FontAwesomeIcon icon="fa-light fa-calendar" /><Element tag={`span`} style={{ width: "5.5875rem" }}>{state.CALC_DATE}</Element></Element><hr />
                    <Element tag={`div`} className={styles.priceArea}><FontAwesomeIcon icon="fa-light fa-coins" /><Element tag={`em`} style={{ width: "5.0625rem" }}>{state.TYPE === 1 ? state.TOT_AMT : null}</Element></Element><hr />
                    <Element tag={`div`} className={styles.priceArea}><FontAwesomeIcon icon="fa-light fa-coins" /><Element tag={`em`} style={{ width: "5.0625rem" }}>{state.CALC_AMT}</Element></Element><hr />
                    <Element tag={`div`} className={styles.stretch}><Element tag={state.CALC_YN === 'Y' ? `h4` : `h5`}>
                        {state.CALC_YN === 'Y' ? '완료' : state.CALC_YN === 'N' ? '예정' : null}</Element>
                    </Element>
                </Element>
            </ul>
        </Element>
    );
}